import { IconList, IconMapPin } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React from 'react';
import classNames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';
import './NavMenu.scss';

export const DEALS_SECTIONS = {
    MAP: 'map',
    LIST: 'list',
};

const NavMenu = ({ activeSection, setActiveSection }: any) => {
    const handleClickSectionTab = (section: string) => {
        setActiveSection(section);
        window.localStorage.setItem('dealsActiveSection', section);
    };

    return (
        <Nav tabs className="border-0">
            <NavItem
                data-testid="nav-tab-map"
                className={classNames(
                    'heap-deal-pipeline-map',
                    'mr-2',
                    { NavMenu__item: activeSection === DEALS_SECTIONS.MAP },
                    { 'NavMenu__item--inactive': activeSection !== DEALS_SECTIONS.MAP },
                )}
            >
                <NavLink
                    href="#"
                    data-toggle="tab"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        handleClickSectionTab(DEALS_SECTIONS.MAP);
                    }}
                    active={activeSection === DEALS_SECTIONS.MAP}
                    className="border-0 rounded"
                >
                    <NSIcon className="mr-2" size="lg" icon={IconMapPin} />
                    Map
                </NavLink>
            </NavItem>
            <NavItem
                data-testid="nav-tab-list"
                className={classNames(
                    'heap-deal-pipeline-list',
                    { NavMenu__item: activeSection === DEALS_SECTIONS.LIST },
                    { 'NavMenu__item--inactive': activeSection !== DEALS_SECTIONS.LIST },
                )}
            >
                <NavLink
                    href="#"
                    data-toggle="tab"
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        handleClickSectionTab(DEALS_SECTIONS.LIST);
                    }}
                    active={activeSection === DEALS_SECTIONS.LIST}
                    className="border-0 rounded"
                >
                    <NSIcon className="mr-2" size="lg" icon={IconList} />
                    List
                </NavLink>
            </NavItem>
        </Nav>
    );
};
export default NavMenu;
